export enum NotificationSubStatus {
    FINALIZADA_COM_TRATATIVA = 'u_finalizada_com_tratativa',
    FINALIZADA_SEM_TRATATIVA = 'u_finalizada_sem_tratativa'
}

export const notificationSubStateOptions = [
    {
        value: NotificationSubStatus.FINALIZADA_COM_TRATATIVA,
        label: 'Finalizada com tratativa'
    },
    {
        value: NotificationSubStatus.FINALIZADA_SEM_TRATATIVA,
        label: 'Finalizada sem tratativa'
    }
]

/**
 * Valida e mapeia o valor do sub-state para o formato usado pelo backend
 * Retorna o próprio valor do enum se válido, ou null caso contrário
 * Serve para garantir que não sejam enviados valores inválidos
 */
export const mapSubStateToBackend = (subState: string): string | null => {
    switch (subState) {
        case NotificationSubStatus.FINALIZADA_COM_TRATATIVA:
            return NotificationSubStatus.FINALIZADA_COM_TRATATIVA // 'u_finalizada_com_tratativa'
        case NotificationSubStatus.FINALIZADA_SEM_TRATATIVA:
            return NotificationSubStatus.FINALIZADA_SEM_TRATATIVA // 'u_finalizada_sem_tratativa'
        default:
            return null
    }
}

/**
 * Busca o item da navbar com o u_sub_state correspondente ao filtro ativo
 */
export const findNavbarItemBySubState = (navbar: any[], navId: number, subState?: string): any | null => {
    if (!navbar || navbar.length === 0) {
        return null
    }

    if (!subState || subState === '') {
        // Se não houver filtro, retorna o item sem u_sub_state (total geral)
        const item = navbar.find((item: any) => item && item.id === navId && !item?.u_sub_state) || null
        return item
    }

    const sub_state = mapSubStateToBackend(subState)
    
    if (!sub_state) {
        const item = navbar.find((item: any) => item && item.id === navId && !item?.u_sub_state) || null
        return item
    }

    // Busca o item com o u_sub_state correspondente
    const foundItem = navbar.find((item: any) => {
        if (!item || item.id !== navId) return false
        
        // Se o item não tem u_sub_state, não é o que procuramos (quando há filtro)
        if (!item?.u_sub_state) {
            return false
        }
        
        // Comparação exata com o valor do banco
        if (item?.u_sub_state === sub_state) {
            return true
        }
        
        // Fallback: verifica se começa com o mesmo prefixo (para casos truncados)
        if (sub_state === NotificationSubStatus.FINALIZADA_SEM_TRATATIVA && item.u_sub_state?.startsWith('u_finalizada_sem_trat')) {
            return true
        }
        if (sub_state === NotificationSubStatus.FINALIZADA_COM_TRATATIVA && item.u_sub_state?.startsWith('u_finalizada_com_trat')) {
            return true
        }
        
        return false
    })
    
    return foundItem || null
}

